
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../redux/library/selector';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import MediaInfoComponent from '../../../../../common/components/common/media-info.component';
import { FaCamera, FaTimes } from 'react-icons/fa';
import UploadFilesContainer from '../../../../../models/upload-url-file';
import _ from 'lodash';


export default function BlogPostBasicInfoComponent ({handleFormBlogPostItemChange,handleInnerFormChange, selectedBlogs}: any) {
  const libraryData = useSelector(selectListItems)
  const [isModalMediaOpen, setModalOpen] = useState(false);
  const [imageUrls, setImageUrls] = useState<string[]>([]);

  // Populate imageUrls with the existing Attachmenturls from selectedTemplate
  useEffect(() => {
    if (selectedBlogs?.Documents?.length > 0) {
      setImageUrls(selectedBlogs.Documents[0]?.BlogPostFileUrl);
    }
  }, [selectedBlogs]);

  const openModal = (e: any) => {
    e.stopPropagation();
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleSaveUrls = (urls: string[]) => {
    setImageUrls(urls);
    selectedBlogs.Documents[0].BlogPostFileUrl = urls; // Update selectedTemplate with new URLs
    closeModal();
  };

   return (
    <>
      {_.map(
                  selectedBlogs,
                  (selectedBlog: any, index: any) => (
     <><AccordionContainer
                      child={<div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                          label="Title"
                          labelField="Title"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormBlogPostItemChange({
                              value: event.target.value,
                              field: 'Title',
                              idx: index
                            });
                          } }
                          type="text"
                          value={selectedBlog?.Title} />
                        <InputContainer
                          label="Caption"
                          labelField="Caption"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormBlogPostItemChange({
                              value: event.target.value,
                              field: 'Caption',
                              idx: index
                            });
                          } }

                          type="text"
                          value={selectedBlog?.Caption} />
                        <InputContainer
                          label="MetaKeywords"
                          labelField="MetaKeywords"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormBlogPostItemChange({
                              value: event.target.value,
                              field: 'MetaKeywords',
                              idx: index
                            });
                          } }


                          type="text"
                          value={selectedBlog?.MetaKeywords} />
                        <InputContainer
                          label="MetaDescription"
                          labelField="MetaDescription"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormBlogPostItemChange({
                              value: event.target.value,
                              field: 'MetaDescription',
                              idx: index
                            });
                          } }


                          type="text"
                          value={selectedBlog?.MetaDescription} />
                        <InputContainer
                          label="MetaTitle"
                          labelField="MetaTitle"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormBlogPostItemChange({
                              value: event.target.value,
                              field: 'MetaTitle',
                              idx: index
                            });
                          } }

                          type="text"
                          value={selectedBlog?.MetaTitle} />
                        <InputContainer
                          label="BlogShow Start Date"
                          labelField="BlogShowStartDateUtc"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormBlogPostItemChange({
                              value: event.target.value,
                              field: 'BlogShowStartDateUtc',
                              idx: index
                            });
                          } }
                          type="date"
                          value={selectedBlog?.BlogShowStartDateUtc} />
                        <InputContainer
                          label="BlogShow End Date"
                          labelField="BlogShowEndDateUtc"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormBlogPostItemChange({
                              value: event.target.value,
                              field: 'BlogShowEndDateUtc',
                              idx: index
                            });
                          } }
                          type="date"
                          value={selectedBlog?.BlogShowEndDateUtc} />
                        <InputContainer
                          label="Comments Allowed"
                          labelField="IsCommentsAllowed"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormBlogPostItemChange({
                              value: event,
                              field: 'IsCommentsAllowed',
                              idx: index
                            });
                          } }
                          type="checkbox"
                          value={selectedBlog?.IsCommentsAllowed} />
                        <InputContainer
                          label="Limited To Stores"
                          labelField="IsLimitedToStores"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormBlogPostItemChange({
                              value: event,
                              field: 'IsLimitedToStores',
                              idx: index
                            });
                          } }
                          type="checkbox"
                          value={selectedBlog?.IsLimitedToStores} />
                        <div className='col-span-full'>
                          <InputContainer
                            label="Body"
                            name="Body"
                            onValueChange={(event: any) => {
                              handleFormBlogPostItemChange({
                                value: event.target.value,
                                field: 'Body',
                                idx: index
                              });
                            } }
                            type="text"
                            value={selectedBlog?.Body} /></div>
                      </div>}
                      expandedPanel="BasicInfo"
                      headerTitle="Basic Info" /><AccordionContainer
                        child={<div className="flex items-center space-x-4">
                          {imageUrls &&
                            <img
                              alt="Uploaded"
                              className="w-12 h-12 object-cover" />}
                          <FaCamera type="button" className="cursor-pointer" onClick={openModal} />
                        </div>}
                        expandedPanel="BlogPost Media Info"
                        headerTitle="BlogPost Media Info" /></>
    )
  )}
       {isModalMediaOpen && (
        <div className="fixed inset-0 ml-80 mt-40 flex w-[1000px] h-[400px] items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded shadow-lg w-full overflow-y-auto">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold mb-4">Add URL</h2>
              <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">
                <FaTimes className="w-6 h-6" />
              </button>
            </div>
            <UploadFilesContainer onSave={handleSaveUrls} />
          </div>
        </div>
      )}
</>
  )
}